import React, { useMemo } from "react";
import { ProductType } from "../../../../../types";
import { getProductImage } from "../../../../../utils/image";

import { GatsbyImage, IGatsbyImageData, getImage } from "gatsby-plugin-image";
import { useWindowSize } from "../../../../../hooks/useWindowSize";
interface Props {
    imagePreview: Partial<ProductType["assets"][0]> | null;
    selectedProduct: ProductType;
    setImagePreview: (image: Partial<ProductType["assets"][0]>) => void;
}

export default function ProductDetailGallery({
    imagePreview,
    selectedProduct,
    setImagePreview
}: Props) {

    const windowSize = useWindowSize();

    const isMobileView = useMemo(
        () => {
            return windowSize?.width ? windowSize.width < 768 : false;
        },
        [windowSize]
    );

    return (
        <>
            <div className="flex flex-wrap -mx-3">
                {!isMobileView && (
                    <div className="relative w-full px-3 mb-4">
                        <div className="pb-[100%]"></div>
                        <GatsbyImage
                            image={getImage(imagePreview) as IGatsbyImageData}
                            alt={`${selectedProduct?.SKUName} image`}
                            className="absolute w-full h-full top-0 left-0 object-contain"
                            style={{
                                position: "absolute",
                            }}
                        />
                    </div>
                )}
                <div className="w-full px-3">
                    <div className="relative overflow-auto">
                        <div
                            className="flex items-center md:-mx-2"
                        >

                            {selectedProduct.imageFile && (
                                <LittleImage
                                    image={getImage(selectedProduct?.imageFile)}
                                    alt={`${selectedProduct?.SKUName} image`}
                                    onClick={() => setImagePreview(selectedProduct?.imageFile)}
                                />
                            )}

                            {selectedProduct?.assets?.map(asset => (
                                <LittleImage
                                    key={asset?.id}
                                    alt={asset?.altTag}
                                    image={getImage(asset?.imageFile)}
                                    onClick={() => setImagePreview(asset?.imageFile)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const LittleImage = ({
    image,
    onClick,
    alt
}: {
    image: any;
    onClick: () => void;
    alt?: string;
}) => (
    <div
        className="
            bg-white
            flex items-center
            mb-3 mb-2 mr-2
            flex-none w-full
            md:mx-2 md:h-full md:w-[100px] md:cursor-pointer
            "
        onClick={onClick}
    >
        <div>
            <GatsbyImage
                image={image as IGatsbyImageData}
                alt={alt ?? "product"}
                objectFit="contain"
            />
        </div>
    </div>
);
